var changeEvent = new Event('change');
var inputEvent = new Event('input');


// reviews slider
(function () {
    if (document.querySelector('.reviews__slider')) {
        var swiper = new Swiper('.reviews__slider', {
            spaceBetween: 18,
            slidesPerView: 1,
            navigation: {
                nextEl: ".reviews .swiper-button-next",
                prevEl: ".reviews .swiper-button-prev",
            },
            breakpoints: {
              768: {
                slidesPerView: 2
              },
              1024: {
                slidesPerView: 3
              }
            }
        });
    }
    if (document.querySelector('.product__main_slider')) {
        var swiperThumbs = new Swiper('.product__thumbnails', {
            spaceBetween: 8,
            slidesPerView: 6,
            breakpoints: {
              768: {
                direction: "vertical",
              },
              1024: {
                slidesPerView: 4,
                direction: "vertical",
              }
            }
        });
        var swiperMain = new Swiper('.product__main_slider', {
          spaceBetween: 18,
          slidesPerView: 1,    
          zoom: true,        
          thumbs: {
            swiper: swiperThumbs,
          },
          mousewheel: {
            forceToAxis: true
          },
          navigation: {
            nextEl: ".product__main_slider .swiper-button-next",
            prevEl: ".product__main_slider .swiper-button-prev",
          },
        }); 

        const galleryParent = document.querySelector('.product__media-wrapper')
        const gallery = document.querySelector('.product__main_slider')
        const closeGallery = document.querySelector('.product__main_slider .closeGallery')
        const overlay = document.querySelector('.overlay')

        gallery.addEventListener('click', (e) => {
          if (e.target.closest('#ZlistWishlist')) return;
          if (!gallery.classList.contains('fullScreen')) {
           gallery.classList.add('fullScreen')
           overlay.classList.add('active')
           document.body.classList.add('overflow-hidden')
           galleryParent.classList.add('active')
          }
      })
      closeGallery.addEventListener('click', (e) => {
        e.stopPropagation()
        gallery.classList.remove('fullScreen')
        overlay.classList.remove('active')
        document.body.classList.remove('overflow-hidden')
        galleryParent.classList.remove('active')
      })
    }
})();
// reviews slider

// collection parts slider
(function () {
  if (document.querySelector('.collection_h2_section__block_slider')) {
    var collectionH2SectionBlockSlider = new Swiper('.collection_h2_section__block_slider', {
      spaceBetween: 24,
      slidesPerView: 1,
      navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 1
        },
        1024: {
          slidesPerView: 2
        }
      }
  });
  }
})();
// collection parts slider

// menu drawer accordion
(function () {
  const menuTitles = document.querySelectorAll('.menu-drawer__link_wr')
  const faqTitles = document.querySelectorAll('.faq__item .faq__title_wr')

  const triggerFaq = (element,titles) => {
    const hideAccordions = () => {
      titles.forEach(element2 => {
        element2.parentElement.classList.remove('open')
        element2.nextElementSibling.classList.remove('open');
        element2.nextElementSibling.style.maxHeight = 0;
      })     
    }

    if (element.parentElement.classList.contains('open')) {
      if (!element.closest('.no-hide')) {
        hideAccordions()
      }   
      element.nextElementSibling.classList.remove('open');
      element.parentElement.classList.remove('open');
      element.nextElementSibling.style.maxHeight = 0;
    } else {
      if (!element.closest('.no-hide')) {
        hideAccordions()
      }

      element.parentElement.classList.add('open');
      element.nextElementSibling.classList.add('open');
      element.nextElementSibling.style.maxHeight = element.nextElementSibling.scrollHeight + 'px'; 
    }
  }
  menuTitles.forEach(element => {
    element.addEventListener('click', () => {
      triggerFaq(element,menuTitles)
    })
  });
  faqTitles.forEach(element => {
    element.addEventListener('click', () => {
      triggerFaq(element,faqTitles)
    })
  });
})();
// menu drawer accordion

// product tabs sticky
// (function () {
//   if(document.body.classList.contains('template_product')) {
//     const el = document.querySelector(".product_content__tabs")
//     const observer = new IntersectionObserver( 
//       ([e]) => e.target.classList.toggle("is-pinned", e.intersectionRatio < 1),
//       { threshold: [1],
//         rootMargin: "0px 0px 300px 0px",
//       }
//     );

//     observer.observe(el);


//     const tabs = document.querySelectorAll(".product_content__tabs_item")
//     const tabSections = document.querySelectorAll(".tab-section")

//     const observerTabs = new IntersectionObserver((entries, observer) => {
//       entries.forEach(entry => {
//         if (entry.boundingClientRect.top < 280)  {
//           const index = Array.from(tabSections).indexOf(entry.target)
//           tabs.forEach(tab => {
//             tab.classList.remove("active")
//             })
//             tabs[index].classList.add("active")
//         }
//       })
//     }, {
//       threshold: [.5, 0],
//       rootMargin: "-280px 0px 0px 0px",
//     })

//     tabSections.forEach(sections => {
//       observerTabs.observe(sections)
//     })
//   }
// })();
// product tabs sticky

// product customers viewed tabs + slider
(function () {
  const initPanelSwiper = (panel, swipers) => {
    panel.querySelectorAll('.product-customers-viewed__slider').forEach((slider) => {
      if (swipers.has(slider)) return;

      const carousel = slider.closest('.product-customers-viewed__carousel');
      if (!carousel) return;

      const isMobileGrid = slider.dataset.layout === 'mobile-grid';

      swipers.set(
        slider,
        new Swiper(slider, {
          spaceBetween: isMobileGrid ? 14 : 24,
          slidesPerView: isMobileGrid ? 1 : 6,
          navigation: {
            nextEl: carousel.querySelector('.carousel-nav__arrow--next'),
            prevEl: carousel.querySelector('.carousel-nav__arrow--prev'),
          },
        })
      );
    });
  };

  document.querySelectorAll('.product-customers-viewed').forEach((section) => {
    const swipers = new Map();
    const panels = section.querySelectorAll('.product-customers-viewed__panel');
    const tabs = section.querySelectorAll('.product-customers-viewed__tab');

    panels.forEach((panel) => {
      if (panel.classList.contains('active')) {
        initPanelSwiper(panel, swipers);
      }
    });

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.tab;
        if (!target) return;

        tabs.forEach((item) => {
          item.classList.remove('active');
          item.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');

        panels.forEach((panel) => {
          const isActive = panel.dataset.tabPanel === target;
          panel.classList.toggle('active', isActive);
          panel.hidden = !isActive;
          if (isActive) {
            initPanelSwiper(panel, swipers);
            panel.querySelectorAll('.product-customers-viewed__slider').forEach((slider) => {
              swipers.get(slider)?.update();
            });
          }
        });
      });
    });
  });
})();
// product customers viewed tabs + slider

// product more collections slider
(function () {
  document.querySelectorAll('.product-more-collections__slider').forEach((slider) => {
    const carousel = slider.closest('.product-more-collections__carousel');
    if (!carousel) return;

    new Swiper(slider, {
      spaceBetween: 24,
      slidesPerView: 'auto',
      navigation: {
        nextEl: carousel.querySelector('.carousel-nav__arrow--next'),
        prevEl: carousel.querySelector('.carousel-nav__arrow--prev'),
      },
    });
  });
})();
// product more collections slider

// product recommedation slider
(function () {
  if (document.querySelector('.related-products__products')) {
    var swiper = new Swiper('.related-products__products', {
        spaceBetween: 24,
        slidesPerView: 'auto',
        navigation: {
            nextEl: ".reviews .swiper-button-next",
            prevEl: ".reviews .swiper-button-prev",
        },
        breakpoints: {
            1024: {
              slidesPerView: 4
            }
          }
    });
  }
})();
// product recommedation slider

// to top button
(function () {
  let mybutton = document.querySelector(".toTop");

  window.onscroll = function() {scrollFunction()};

  function scrollFunction() {
    if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
      mybutton.classList.add('active')
    } else {
      mybutton.classList.remove('active')
    }
  }

})();
// to top button

// close popups
(function () {
  const overlay = document.querySelector('.overlay')
  const productGallery = document.querySelector('.product__main_slider')
  const galleryParent = document.querySelector('.product__media-wrapper')
  window.addEventListener('click', e => {
    if (e.target == overlay) {
      overlay.classList.remove('active')
      document.body.classList.remove('overflow-hidden')
      if (productGallery) {
        productGallery.classList.remove('fullScreen')
        galleryParent.classList.remove('active') 
      }
    }
  })
})();
// close popups


// filter on the hero
(function () {
  if (document.querySelector('#brandCustomSelect')) {
    const brandCustomSelect = document.getElementById('brandCustomSelect');
    const brandSelectOptions = document.getElementById('brandSelectOptions');
    const modelCustomSelect = document.getElementById('modelCustomSelect');
    const modelSelectOptions = document.getElementById('modelSelectOptions');
    const clearFilters = document.getElementById('clearFilters');
    const searchButton = document.getElementById('searchButtonJson');
    const searchButtonBundle = document.getElementById('searchButtonBundles');
    const popup = document.querySelector('.productList_popup');
    const productList = document.getElementById('productList');
    const filterContainerJson = document.querySelector('.filter-container-json');

    // OLD: товары брались из заранее выгруженного файла на CDN (большой JSON)
    // const productsJsonUrl = 'https://cdn.shopify.com/s/files/1/0825/7490/1549/files/no_kit_product.json?v=1747319895';
    const brandsModelsJsonUrl = (filterContainerJson && filterContainerJson.dataset.json) || 'https://udcparts.com/cdn/shop/t/7/assets/brand_lawn_models.json?v=35128508592143359101722628297';

    let localJson;
    let productsJson;
    let productsJsonPromise = null;

    // NEW: товары берём напрямую из публичного Shopify endpoint'а.
    // Загружаем по 250 штук (page=1, затем page=2 и т.д.), пока не закончатся результаты.
    const shopifyProductsBaseUrl = 'https://udcparts.com/products.json';
    const shopifyProductsPageSize = 250;

    async function loadAllShopifyProducts() {
      const allProducts = [];
      let page = 1;

      while (true) {
        const url = `${shopifyProductsBaseUrl}?limit=${shopifyProductsPageSize}&page=${page}`;
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`Failed to load products.json (status=${response.status}) page=${page}`);
        }

        const data = await response.json();
        const pageProducts = Array.isArray(data?.products) ? data.products : [];

        allProducts.push(...pageProducts);

        // Если пришло меньше pageSize — значит дальше товаров нет.
        if (pageProducts.length < shopifyProductsPageSize) break;
        page++;
      }

      // Приводим к формату как раньше: { products: [...] }
      return { products: allProducts };
    }

    function ensureProductsJsonLoaded() {
      if (productsJson) {
        return Promise.resolve(productsJson);
      }

      if (!productsJsonPromise) {
        productsJsonPromise = loadAllShopifyProducts()
          .then(data => {
            productsJson = data;
            return productsJson;
          })
          .catch(error => {
            productsJsonPromise = null;
            throw error;
          });
      }

      return productsJsonPromise;
    }

    if (searchButton) {
      searchButton.disabled = true;
    }
    if (searchButtonBundle) {
      searchButtonBundle.disabled = true;
    }

    fetch(brandsModelsJsonUrl)
      .then(response => response.json())
      .then(data => {
        localJson = data;
        populateBrandDropdown(localJson);

        if (document.querySelector('.filter-container-json') && searchButton) {
          searchButton.addEventListener('click', async () => {
            const selectedBrand = brandCustomSelect.querySelector('.select-selected').value;
            const selectedModel = modelCustomSelect.querySelector('.select-selected').value;

            if (selectedBrand === 'Choose make' || selectedModel === 'Choose model') return;
            if (!localJson[selectedBrand] || !localJson[selectedBrand][selectedModel]) return;

            showSpinner();
            try {
              await ensureProductsJsonLoaded();
              const productIds = localJson[selectedBrand][selectedModel];
              const filteredProducts = productsJson.products.filter(product => {
                const normalizedTitle = product.title.toLowerCase().replace(/\s+/g, ' ').trim();
                return productIds.some(idGroup => {
                  const ids = idGroup.split(',').map(id => id.trim().toLowerCase());
                  return ids.some(id => normalizedTitle.includes(id));
                });
              });

              displayProducts(filteredProducts);
            } catch (error) {
              console.error('Error filtering products:', error);
            } finally {
              hideSpinner();
            }
          });
        }

        if (document.querySelector('.filter-container_bundle') && searchButtonBundle) {
          searchButtonBundle.addEventListener('click', async () => {
            const selectedBrand = brandCustomSelect.querySelector('.select-selected').value.trim().toLowerCase();
            const selectedModel = modelCustomSelect.querySelector('.select-selected').value.trim().toLowerCase();

            if (selectedBrand === 'choose make' || selectedModel === 'choose model') return;

            showSpinner();
            try {
              await ensureProductsJsonLoaded();
              const filteredProducts = productsJson.products.filter(product => {
                let isAvailable = true;
                product.variants.forEach(variant => {
                  if (!variant.available) {
                    isAvailable = false;
                  }
                });
                const normalizedBodyHtml = product.body_html.toLowerCase().replace(/\s+/g, ' ').trim();
                const normalizedTitle = product.title.toLowerCase().replace(/\s+/g, ' ').trim();
                const normalizedTags = product.tags.join(' ').toLowerCase().replace(/\s+/g, ' ').trim();

                const brandMatch =
                  normalizedBodyHtml.includes(selectedBrand) ||
                  normalizedTitle.includes(selectedBrand) ||
                  normalizedTags.includes(selectedBrand);

                const modelMatch =
                  normalizedBodyHtml.includes(selectedModel) ||
                  normalizedTitle.includes(selectedModel) ||
                  normalizedTags.includes(selectedModel) ||
                  normalizedBodyHtml.includes(selectedModel.replace(/-/g, ' ')) ||
                  normalizedTitle.includes(selectedModel.replace(/-/g, ' ')) ||
                  normalizedTags.includes(selectedModel.replace(/-/g, ' ')) ||
                  normalizedBodyHtml.includes(selectedModel.replace(/-/g, '')) ||
                  normalizedTitle.includes(selectedModel.replace(/-/g, '')) ||
                  normalizedTags.includes(selectedModel.replace(/-/g, ''));

                return brandMatch && modelMatch && isAvailable;
              });

              displayBundleProducts(filteredProducts);
            } catch (error) {
              console.error('Error filtering bundle products:', error);
            } finally {
              hideSpinner();
            }
          });
        }

        clearFilters.addEventListener('click', resetFilters);
      })
      .catch(error => console.error('Error loading JSON:', error));

    function populateBrandDropdown(data) {
      brandSelectOptions.innerHTML = '';
      Object.keys(data).forEach(brand => {
        const div = document.createElement('div');
        div.textContent = brand;
        div.addEventListener('click', async function() {
          selectOption(this, brandCustomSelect, brandSelectOptions);
          resetModelSelect();
          showSpinner();
          try {
            await ensureProductsJsonLoaded();
            filterModelsByBrand(brand);
            enableModelSelect();
          } catch (error) {
            console.error('Error loading products for models list:', error);
            hideSpinner();
          }
        });
        brandSelectOptions.appendChild(div);
      });
    }

    function filterModelsByBrand(selectedBrand) {
      const brandModels = localJson[selectedBrand];
      const availableModels = [];
      selectedBrand = selectedBrand.trim().toLowerCase()
      const modelKeys = Object.keys(brandModels);
      let index = 0;
  
      showSpinner(); // Показываем спиннер перед началом фильтрации
  
      function processNextModel() {
          if (index < modelKeys.length) {
              const model = modelKeys[index];
              const normalizedModel = model.toLowerCase().replace(/\s+/g, ' ').trim();
  
              // console.log('Checking Model:', model);
  
              const hasProducts = productsJson.products.some(product => {
                  let isAvailable = product.variants.some(variant => variant.available);
  
                  const normalizedBodyHtml = product.body_html.toLowerCase().replace(/\s+/g, ' ').trim();
                  const normalizedTitle = product.title.toLowerCase().replace(/\s+/g, ' ').trim();
                  const normalizedTags = product.tags.join(' ').toLowerCase().replace(/\s+/g, ' ').trim();
  
                  const brandMatch = normalizedBodyHtml.includes(selectedBrand) || 
                                     normalizedTitle.includes(selectedBrand) || 
                                     normalizedTags.includes(selectedBrand);
  
                  const modelMatch = normalizedBodyHtml.includes(normalizedModel) || 
                                     normalizedTitle.includes(normalizedModel) || 
                                     normalizedTags.includes(normalizedModel);
                                     
                  return brandMatch && modelMatch && isAvailable;
              });
  
              if (hasProducts) {
                  availableModels.push(model);
              } 
  
              index++;
              setTimeout(processNextModel, 0); // Позволяем браузеру обновить интерфейс между итерациями
          } else {
              updateModelDropdown(availableModels); // Когда все модели обработаны
              hideSpinner(); // Скрываем спиннер после завершения фильтрации
          }
      }
  
      processNextModel(); // Запуск обработки моделей
    }
    
    function updateModelDropdown(availableModels) {
      modelSelectOptions.innerHTML = ''; // Очистка текущих опций

      for (const index in availableModels) {
          if (availableModels.hasOwnProperty(index)) {
              const model = availableModels[index];
              const div = document.createElement('div');
              div.textContent = model;
              div.addEventListener('click', function() {
                  selectOption(this, modelCustomSelect, modelSelectOptions);
              });
              modelSelectOptions.appendChild(div);
          }
      }

      if (availableModels.length === 0) {
          console.log('No available models for selected brand.');
          const div = document.createElement('div');
          div.textContent = "No models available";
          modelSelectOptions.appendChild(div);
      }
    }
  
    function selectOption(element, selectWrapper, selectOptions) {
      const selected = selectWrapper.querySelector('.select-selected');
      selected.value = element.textContent;
      selectOptions.classList.add('select-hide');
      selectWrapper.classList.add('selected');
      const sameAsSelected = selectWrapper.getElementsByClassName('same-as-selected');
      for (let i = 0; i < sameAsSelected.length; i++) {
          sameAsSelected[i].classList.remove('same-as-selected');
      }
      element.classList.add('same-as-selected');
      
      checkIfSearchEnabled();
    }

    function removeOptionsActiveClass() {
      document.querySelectorAll('.select-items div').forEach(el => {
        el.classList.remove('same-as-selected')
      });
    }

    function addCustomSelectEventListener(selectWrapper, selectOptions) {
        selectWrapper.querySelector('.select-selected').addEventListener('click', function(e) {
            if (!this.classList.contains('disabled')) {
                closeAllSelect(this);
                selectOptions.classList.toggle('select-hide');
                if (!selectOptions.classList.contains('select-hide')) {
                    selectWrapper.classList.add('active');
                } else {
                    selectWrapper.classList.remove('active');
                }
            }
        });
    }

    addCustomSelectEventListener(brandCustomSelect, brandSelectOptions);
    addCustomSelectEventListener(modelCustomSelect, modelSelectOptions);

    function closeAllSelect(element) {
        const selectItems = document.getElementsByClassName('select-items');
        const selectSelected = document.getElementsByClassName('select-selected');
        for (let i = 0; i < selectSelected.length; i++) {
            if (element !== selectSelected[i]) {
                selectSelected[i].nextElementSibling.classList.add('select-hide');
                selectSelected[i].parentNode.classList.remove('active');
            }
        }
    }

    document.addEventListener('click', function(event) {
        if (!event.target.closest('.custom-select-wrapper')) {
            const selectItems = document.getElementsByClassName('select-items');
            for (let i = 0; i < selectItems.length; i++) {
                selectItems[i].classList.add('select-hide');
                selectItems[i].parentNode.classList.remove('active');
            }
        }
    });

    function displayProducts(products) {
        productList.innerHTML = '';
        if (document.querySelector('.no_available')) {
          document.querySelector('.no_available').remove();
        }
        if (products.length > 0) {
          products.forEach(product => {
            const productDiv = document.createElement('div');
            productDiv.className = 'card_product';
            productDiv.innerHTML = `
                <div class="card_product__media">
                  <div class="card__media">
                    <div class="media media--transparent media--hover-effect">
                    <img src="${product.images[0]?.src || ''}" alt="${product.title}" class="motion-reduce">
                    <img src="${product.images[1]?.src || ''}" alt="${product.title}" class="motion-reduce">
                    </div>
                  </div>
                </div>
                <div class='card__title'>${product.title}</div>
                <div class="card__price title">
                  <div class="
                      price  ${product.variants[0]?.compare_at_price != null ? `price--on-sale`: `1`}">
                    <div class="price__container">
                      <div class="price__regular">
                          <span class="price-item price-item--regular" bss-b2b-product-id="${product.id}" bss-b2b-product-parent-price="true" style="visibility: visible;">
                          <span bss-b2b-product-id="${product.id}" bss-b2b-product-price="" bss-b2b-product-active="true" style="visibility: visible;">
                            $${product.variants[0]?.price}
                          </span></span></div>
                      <div class="price__sale">
                            <s class="price-item price-item--regular">
                              $${product.variants[0]?.compare_at_price}
                            </s>
                          </span>
                        <span class="price-item price-item--sale price-item--last" bss-b2b-product-id="${product.id}" bss-b2b-product-parent-price="true" style="visibility: visible;"><span bss-b2b-product-id="${product.id}" bss-b2b-product-price="" bss-b2b-product-active="true" style="visibility: visible;">
                          $${product.variants[0]?.price}
                        </span></span>
                      </div>
                      <small class="unit-price caption hidden">
                        
                        <span class="price-item price-item--last">
                          <span></span>
                          <span aria-hidden="true">/</span>
                          
                          <span>
                          </span>
                        </span>
                      </small>
                    </div></div>
                  </div>
                <a href="/products/${product.handle}" target="_blank"></a>
            `;
            productList.appendChild(productDiv);
          });
        } else {
          const productDiv = document.createElement('div');
          productDiv.className = 'no_available';
          productDiv.innerHTML = "Sorry, no parts available for your mower model";
          document.querySelector('.productList_wr').appendChild(productDiv);
        }
        
        popup.classList.add('active');
        document.body.classList.add('overflow-hidden');
    }

    function displayBundleProducts(products) {
      productList.classList.remove('hidden');
      if (document.querySelector('.no_available')) {
        document.querySelector('.no_available').remove();
        document.querySelector('.productList_popup_add_to_bundle').classList.remove('hidden');
      }
      const categories = document.querySelectorAll('.productList__category');

      categories.forEach(category => {
        const categoryItems = category.querySelector('.productList__category_items');
        const title = category.querySelector('.productList__category_title');

        categoryItems.innerHTML = '';
        title.innerHTML = title.dataset.title;
        title.nextElementSibling.style.display = 'block';

        let counter = 0;
        if (products.length > 0) {
          products.forEach((product, index) => {
            if (product.product_type == category.dataset.category) {
              const productDiv = document.createElement('div');
              productDiv.className = 'card_product';
              productDiv.dataset.category = category.dataset.category.toLowerCase().replace(/ /g, "_");
              productDiv.innerHTML = `
                    <div class="card_product_input_wr custom_checkbox">
                      <input type="checkbox" name="${category.dataset.category}" id="${category.dataset.category}_${index}" value="${product.variants[0].id}" data-handle="${product.handle}">
                      <label for="${category.dataset.category}_${index}"></label>
                    </div>
                  <div class="card_product__media">
                    <div class="card__media">
                      <div class="media media--transparent media--hover-effect">
                      <img src="${product.images[0]?.src || ''}" alt="${product.title}" class="motion-reduce">
                      <img src="${product.images[1]?.src || ''}" alt="${product.title}" class="motion-reduce">
                      </div>
                    </div>
                  </div>
                  <div class='card__title'>${product.title}</div>
                  <div class="card__price title">
                    <div class="
                        price  ${product.variants[0]?.compare_at_price != null ? `price--on-sale`: `1`}">
                      <div class="price__container">
                        <div class="price__regular">
                        
                            <span class="price-item price-item--regular" bss-b2b-product-id="${product.id}" bss-b2b-product-parent-price="true" style="visibility: visible;">
                            <span bss-b2b-product-id="${product.id}" bss-b2b-product-price="" bss-b2b-product-active="true" style="visibility: visible;">
                              $${product.variants[0]?.price}
                            </span></span></div>
                        <div class="price__sale">
                            
                            <span>
                              <s class="price-item price-item--regular">
                                $${product.variants[0]?.compare_at_price}
                              </s>
                            </span>
                          <span class="price-item price-item--sale price-item--last" bss-b2b-product-id="${product.id}" bss-b2b-product-parent-price="true" style="visibility: visible;"><span bss-b2b-product-id="${product.id}" bss-b2b-product-price="" bss-b2b-product-active="true" style="visibility: visible;">
                            $${product.variants[0]?.price}
                          </span></span>
                        </div>
                        <small class="unit-price caption hidden">
                          
                          <span class="price-item price-item--last">
                            <span></span>
                            <span aria-hidden="true">/</span>
                            
                            <span>
                            </span>
                          </span>
                        </small>
                      </div></div>
                    </div>
                  <a href="/products/${product.handle}" target="_blank"></a>
              `;
              categoryItems.appendChild(productDiv);
              counter++;
            }
          });

          if (counter == 0) {
            title.innerHTML = `${title.innerHTML} <span class="noResults">No results</span>`;
            title.nextElementSibling.style.display = 'none';
          }
        } 
      });
      if (products.length == 0) {
        productList.classList.add('hidden');
        const productDiv = document.createElement('div');
        productDiv.className = 'no_available';
        productDiv.textContent = "Sorry, no parts available for your mower model";
        document.querySelector('.productList_wr').appendChild(productDiv);
        document.querySelector('.productList_popup_add_to_bundle').classList.add('hidden');
      }
      sortCategories();
      initCheckboxes();
      popup.classList.add('active');
      document.body.classList.add('overflow-hidden');
    }

    function sortCategories() {
      const categories = Array.from(document.querySelectorAll('.productList__category'));
    
      // Определяем приоритеты категорий
      const priorityOrder = ['Belts', 'Blades', 'Pulleys', 'Spindles', 'Clutch Cables', 'Control Cables', 'Tension Springs'];
    
      categories.forEach(category => {
        category.classList.remove('has-products', 'no-products');
      });
    
      // Классифицируем категории на "с продуктами" и "без продуктов"
      const categorized = categories.map(category => {
        const productItems = category.querySelector('.productList__category_items');
        const hasProducts = productItems && productItems.getElementsByClassName('card_product').length > 0;
        
        if (hasProducts) {
          category.classList.add('has-products');
        } else {
          category.classList.add('no-products');
        }
        
        return { element: category, hasProducts };
      });
    
      // Сортируем категории
      categorized.sort((a, b) => {
        const aTitle = a.element.getAttribute('data-category');
        const bTitle = b.element.getAttribute('data-category');
    
        if (a.hasProducts && b.hasProducts) {
          return priorityOrder.indexOf(aTitle) - priorityOrder.indexOf(bTitle);
        }
        
        return a.hasProducts ? -1 : 1;
      });
    
      // Перемещаем категории в DOM
      const container = document.getElementById('productList');
      categorized.forEach(item => container.appendChild(item.element));
    }
    

    function resetFilters() {
        brandCustomSelect.querySelector('.select-selected').value = '';
        modelCustomSelect.querySelector('.select-selected').value = '';
        modelSelectOptions.innerHTML = '';
        modelCustomSelect.querySelector('.select-selected').classList.add('disabled');
        const activeSelects = document.querySelectorAll('.custom-select.active, .custom-select.selected');
        activeSelects.forEach(function(select) {
            select.classList.remove('active', 'selected');
        });
        removeOptionsActiveClass();
    }

    function resetModelSelect() {
        modelCustomSelect.querySelector('.select-selected').value = '';
        modelCustomSelect.querySelector('.select-selected').classList.add('disabled');
        modelSelectOptions.innerHTML = '';
        modelCustomSelect.classList.remove('selected');
    }

    function enableModelSelect() {
        modelCustomSelect.querySelector('.select-selected').classList.remove('disabled');
        modelCustomSelect.querySelector('.select-selected').removeAttribute('disabled');
    }

    const initCheckboxes = () => {
        const categories = document.querySelectorAll('.productList__category');
      
        categories.forEach(categoryElement => {
          const category = categoryElement.dataset.category;
          const checkboxes = categoryElement.querySelectorAll('.card_product input[type="checkbox"]');
          const counterElement = categoryElement.querySelector('.counter');
          const maxSelectable = (category === 'Belts' || category === 'Blades') ? 2 : 1;
      
          checkboxes.forEach(checkbox => {
            checkbox.addEventListener('change', function() {
              let checkedCheckboxes = categoryElement.querySelectorAll('.card_product input[type="checkbox"]:checked');
              if (maxSelectable === 1) {
                checkboxes.forEach(cb => {
                  if (cb !== this) {
                    cb.checked = false;
                  }
                });
                checkedCheckboxes = categoryElement.querySelectorAll('.card_product input[type="checkbox"]:checked');
              }
      
              if (maxSelectable === 2 && checkedCheckboxes.length > 2) {
                this.checked = false;
                checkedCheckboxes = categoryElement.querySelectorAll('.card_product input[type="checkbox"]:checked');
              }

              
              counterElement.textContent = checkedCheckboxes.length;
            });
          });
        }); 
    }
     
 
     // Функция для проверки, выбраны ли оба дропдауна
    function checkIfSearchEnabled() {
      const selectedBrand = brandCustomSelect.querySelector('.select-selected').value;
      const selectedModel = modelCustomSelect.querySelector('.select-selected').value;
      
      if (selectedBrand !== '' && selectedModel !== '') {
        if (searchButton) {
          searchButton.disabled = false;          
        }
        if (searchButtonBundle) {
          searchButtonBundle.disabled = false;
        }
      } else {
        if (searchButton) {
          searchButton.disabled = true;          
        }
        if (searchButtonBundle) {
          searchButtonBundle.disabled = true;
        }
      }
    }
 
     // Добавляем проверку при изменении модели
     modelCustomSelect.querySelector('.select-selected').addEventListener('click', checkIfSearchEnabled);
     

     document.getElementById('brandInput').addEventListener('input', function() {
      filterSelectOptions('brandInput', 'brandSelectOptions');
    });
    
    document.getElementById('modelInput').addEventListener('input', function() {
        filterSelectOptions('modelInput', 'modelSelectOptions');
    });
    
    function filterSelectOptions(inputId, optionsId) {
        const input = document.getElementById(inputId);
        const filter = input.value.toLowerCase();
        const divs = document.getElementById(optionsId).getElementsByTagName('div');
        
        for (let i = 0; i < divs.length; i++) {
            const txtValue = divs[i].textContent || divs[i].innerText;
            if (txtValue.toLowerCase().indexOf(filter) > -1) {
                divs[i].style.display = "";
            } else {
                divs[i].style.display = "none";
            }
        }

        if (inputId == "brandInput" && filter == '') {
          document.getElementById('modelInput').setAttribute('disabled', true);
        }
    }

    function showSpinner() {
      document.getElementById('spinner').classList.add('active');
  }
  
    function hideSpinner() {
        document.getElementById('spinner').classList.remove('active');
    }
  }
})();

// filter on the hero

// hero bottom slider
(function () {
  if (document.querySelector('.hero_banner__bottom_content')) {
    var init = false;
    var swiper;
    function hero_bottom_slider() {
      if (window.innerWidth <= 768) {
        if (!init) {
          init = true;
          swiper = new Swiper(".hero_banner__bottom_content", {
            direction: "horizontal",
            slidesPerView: 1,
            spaceBetween: 32,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
          });
        }
      } else if (init) {
        swiper.destroy();
        init = false;
      }
    }
    hero_bottom_slider();
    window.addEventListener("resize", hero_bottom_slider);
  }
})();
// hero bottom slider

// add button back to account page
(function () {
  const url = new URL(window.location.href);

  if (url.searchParams.has('from_account')) {
    const newElement = document.createElement('a');
    newElement.href = 'https://udcparts.com/account'
    newElement.classList.add('back_to_account')
    newElement.textContent = 'Back to the account page';

    const targetElement = document.getElementById('MainContent'); 

    if (targetElement) {
        targetElement.appendChild(newElement);
    } 

    document.addEventListener("DOMContentLoaded", function() {
      const header = document.querySelector('.header');
  
      function updateLeftPosition() {
        const headerRect = header.getBoundingClientRect();
        const headerPaddingLeft = window.getComputedStyle(header).paddingLeft;
        newElement.style.left = `${headerRect.left + parseFloat(headerPaddingLeft)}px`;
    }
  
      // Обновляем позицию при загрузке страницы
      updateLeftPosition();
  
      // Обновляем позицию при изменении размера окна
      window.addEventListener('resize', updateLeftPosition);
  });
  
  }

})();
// add button back to account page

// redirect from page 1
(function () {
  if (document.body.classList.contains('template_collection')) {
    if (window.location.search) {
      const params = new URLSearchParams(window.location.search);
      if (params.get('page') === '1') {
        const cleanUrl = window.location.origin + window.location.pathname;
        window.location.href = cleanUrl;
      }
    }
  }
})();
// redirect from page 1

// custom select
(function () {
  document.addEventListener('DOMContentLoaded', function() {
    // Get all custom select wrappers
    const selectWrappers = document.querySelectorAll('.customSelectWrapper');

    selectWrappers.forEach(wrapper => {
        const select = wrapper.querySelector('.customSelect');
        const selected = select.querySelector('.selectSelected');
        const options = select.querySelector('.selectItems');

        // Toggle select dropdown
        selected.addEventListener('click', function(event) {
            options.classList.toggle('select-hide');
            select.classList.toggle('select-arrow-active');
            closeAllSelect(wrapper);
            event.stopPropagation();
        });

        // Select an item
        options.querySelectorAll('div').forEach(option => {
            option.addEventListener('click', function(event) {
              if (!selected.classList.contains('no_change_text')) {
                selected.value = this.textContent;
              }
                options.classList.add('select-hide');
                select.classList.remove('select-arrow-active');
                event.stopPropagation();
            });
        });
    });

    // Close dropdown if clicked outside
    document.addEventListener('click', function(event) {
        closeAllSelect();
    });

    function closeAllSelect(exceptWrapper) {
        selectWrappers.forEach(wrapper => {
            if (wrapper !== exceptWrapper) {
                const select = wrapper.querySelector('.customSelect');
                const options = select.querySelector('.selectItems');
                options.classList.add('select-hide');
                select.classList.remove('select-arrow-active');
            }
        });
    }
});
})();
// custom select

if (document.querySelector('.popup')) {
  const closePopup = () => {
    // Если закрыли #discount_popup, записываем в sessionStorage
    if (document.querySelector('#discount_popup.active')) {
      localStorage.setItem('discountPopupClosed', 'true');
    }
    document.querySelectorAll('.popup').forEach(el => {
      el.classList.remove('active');
    });
    document.body.classList.remove('overflow-hidden');

    
  };

  document.querySelectorAll('.close_popup').forEach(el => {
    el.addEventListener('click', closePopup);
  });

  document.querySelectorAll('.popup .productList_popup__overlay').forEach(el => {
    el.addEventListener('click', closePopup);
  });
}

// add "+" to b2b table
(function () {
  function addPlusToQuantityColumn() {
    const rows = document.querySelectorAll('.quantity_break_table tbody tr');
    rows.forEach(row => {
      const firstCell = row.querySelector('td:first-child');
      if (firstCell && !firstCell.textContent.includes('+')) {
        firstCell.textContent += ' +';
      }
    });
  }
  
  // Настройка наблюдателя
  const observer = new MutationObserver((mutationsList, observer) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        const addedNodes = Array.from(mutation.addedNodes);
        const targetNode = addedNodes.find(node => 
          node.nodeType === Node.ELEMENT_NODE && node.classList.contains('bss-b2b-cart-item-qty-table')
        );
        if (targetNode) {
          addPlusToQuantityColumn();
        }
      }
    }
  });
  
  // Начало наблюдения за изменениями в корневом элементе
  const config = { childList: true, subtree: true };
  const rootElement = document.body;
  observer.observe(rootElement, config);
})();
// add "+" to b2b table

// show/hide lists in header menu
(function () {
  const titles = document.querySelectorAll('.childlist__title.open_content')

  titles.forEach(el => {
    el.addEventListener('click', () => {

      const hideItems = () => {
        titles.forEach(element2 => {
          element2.classList.remove('active')
          element2.parentElement.classList.remove('open')
          element2.nextElementSibling.classList.remove('open');
          element2.nextElementSibling.style.maxHeight = 0;
        })     
      }
      

      if (el.parentElement.classList.contains('open')) {
        hideItems()
        el.nextElementSibling.classList.remove('open');
        el.parentElement.classList.remove('open');
        el.nextElementSibling.style.maxHeight = 0;
        
        el.classList.remove('active')
      } else {
        hideItems()

        el.classList.add('active')
        el.parentElement.classList.add('open');
        el.nextElementSibling.classList.add('open');
        el.nextElementSibling.style.maxHeight = el.nextElementSibling.scrollHeight + 'px'; 
      }
    })
  }) 
})();
// show/hide lists in header menu

// open childlink drawer in mobile menu
(function () {
  const openDrawerButtons = document.querySelectorAll('.open_drawer')
  const childLinkDrawers = document.querySelectorAll('.header__nav_childlist_drawer')
  const closeDrawer = document.querySelectorAll('.header__nav_childlist_drawer_top')

  openDrawerButtons.forEach(el => {
    el.addEventListener('click', () => {
      const targetDrawer = el.dataset.parent
  
      childLinkDrawers.forEach(drawer => {
        if (drawer.dataset.parent == targetDrawer) {
          drawer.classList.add('active')
        }
      })
    })
  })

  closeDrawer.forEach(el => {
    el.addEventListener('click', () => {
      childLinkDrawers.forEach(element => {
        element.classList.remove('active')
      })
    })
  })
})();
// open childlink drawer in mobile menu

// double click on mobile devices
(function () {
  const links = document.querySelectorAll('.mobile_dblclck');
  let tapTimeout;

  links.forEach(link => {
    link.addEventListener('touchstart', function(event) { // Блокируем переход по одиночному касанию
      
      if (tapTimeout) {
        // Если таймер уже установлен, то это двойное касание
        clearTimeout(tapTimeout);
        window.location.href = link.querySelector('.mobile_pointer_events_none').href; // Переходим по ссылке при двойном касании
        tapTimeout = null;
      } else {
        // Если это первое касание, запускаем таймер
        tapTimeout = setTimeout(() => {
          tapTimeout = null; // Сброс таймера, если не последовало двойного касания
        }, 300); // Установите время ожидания для двойного касания
      }
  });
  })
})();
// double click on mobile devices

// discount popup
(function () {
  const discountPopup = document.querySelector('#discount_popup');

  if (discountPopup) {
    // Если попап не закрывали в текущей сессии — показываем
    if (!localStorage.getItem('discountPopupClosed') && !discountPopup.classList.contains('hidden')) {
      discountPopup.classList.add('active');
      document.body.classList.add('overflow-hidden');
    }

    const togglers = document.querySelectorAll('.discount_popup__toggler');
    const discountPopupBlocks = document.querySelectorAll('.discount_popup__block');

    togglers.forEach(toggler => {
      toggler.addEventListener('click', () => {
        // Убираем активный класс у всех тогглеров
        document.querySelector('.discount_popup__toggler.active')?.classList.remove('active');
        toggler.classList.add('active');

        // Убираем активный класс у всех блоков
        document.querySelector('.discount_popup__block.active')?.classList.remove('active');

        // Находим и активируем нужный блок по data-user
        const targetBlock = document.querySelector(`.discount_popup__block[data-user="${toggler.dataset.user}"]`);
        targetBlock?.classList.add('active');
      });
    });
    
    const buttons = document.querySelectorAll('.discount_popup__button');

    buttons.forEach(button => {
      button.addEventListener('click', () => {
        localStorage.setItem('discountPopupClosed', 'true');
      });
    })
  }
})();

// discount popup
    

// b2b_8 slider
(function (){
  if (document.querySelector('.b2b_8__slider')) {
    var swiper = new Swiper('.b2b_8__slider', {
      spaceBetween: 18,
      slidesPerView: 1,
      navigation: {
          nextEl: ".b2b_8__slider .swiper-button-next",
          prevEl: ".b2b_8__slider .swiper-button-prev",
      }
    });
  }
})();
// b2b_8 slider

// product tabs: anchor navigation (all breakpoints, all blocks visible)
(function () {
  const getScrollOffset = (tabsBar) => (tabsBar ? tabsBar.offsetHeight + 20 : 100);

  const scrollToTarget = (selector, tabsBar) => {
    const target = document.querySelector(selector);
    if (!target) return;
    const top = target.getBoundingClientRect().top + window.scrollY - getScrollOffset(tabsBar);
    window.scrollTo({ top, behavior: 'smooth' });
  };

  const setActiveNav = (tabButtons, activeEl) => {
    tabButtons.forEach((btn) => btn.classList.remove('active'));
    activeEl.classList.add('active');
  };

  const initProductTabs = () => {
    const tabsBar = document.querySelector('.product__info-blocks .product_content__tabs');
    if (!tabsBar) return;

    const tabButtons = Array.from(tabsBar.querySelectorAll('.product_content__tabs_item'));
    if (!tabButtons.length) return;

    tabButtons.forEach((button) => {
      if (button.dataset.tabListenerAttached) return;
      button.dataset.tabListenerAttached = 'true';

      button.addEventListener('click', function (e) {
        const hash = this.getAttribute('href');
        const scrollSelector = this.dataset.scrollTarget || (hash && hash.startsWith('#') ? hash : null);
        if (!scrollSelector) return;

        e.preventDefault();
        setActiveNav(tabButtons, this);
        scrollToTarget(scrollSelector, tabsBar);
        history.replaceState(null, '', scrollSelector);
      });
    });
  };

  document.addEventListener('DOMContentLoaded', initProductTabs);
})();

// Judge.me preview badge → product Reviews tab + scroll
(function () {
  document.addEventListener(
    'click',
    function (e) {
      if (e.button !== 0) return;
      const badge = e.target.closest('.jdgm-widget.jdgm-preview-badge');
      if (!badge || !badge.classList.contains('jdgm--done-setup')) return;
      const reviewsTab =
        document.querySelector('.product_content__tabs_item[href="#product-reviews"]') ||
        document.querySelector('.product_content__tabs_item[data-tab="review"]');
      if (!reviewsTab) return;
      e.preventDefault();
      e.stopPropagation();
      reviewsTab.click();
      window.requestAnimationFrame(function () {
        reviewsTab.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    },
    true
  );
})();

// product compatible with accordion
(function () {
  const initCompatibleWith = (root) => {
    root.querySelectorAll('.product-compatible__brand-header').forEach((button) => {
      button.addEventListener('click', () => {
        const brand = button.closest('.product-compatible__brand');
        const isOpen = brand.classList.toggle('is-open');
        button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });

    root.querySelectorAll('.product-compatible__specific-row').forEach((row) => {
      const text = row.querySelector('.product-compatible__numbers-text');
      const toggle = row.querySelector('.product-compatible__numbers-toggle');
      if (!text || !toggle) return;

      const needsToggle = text.textContent.trim().length > 35 || text.scrollHeight > 22;
      if (needsToggle) {
        row.classList.add('is-expandable');
      }

      toggle.addEventListener('click', () => {
        const isExpanded = row.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      });
    });
  };

  document.querySelectorAll('.product-compatible').forEach(initCompatibleWith);
})();